import axios from 'axios';
import { FORM_NAME_ENUMS } from '@shared/variables/form-name.enums';
import HelperS from './helper.service';
// import NotificationS from './notification.service';
import store from '../../store';

export default {
  getIssue(aliasId, projectAliasId, issueId) {
    return axios.get(`/api/project/${aliasId}/${projectAliasId}/issue/${issueId}`).then((res) => {
      store.dispatch('setIssue', res.data);
      return res.data;
    });
  },
  getIssues(aliasId, projectAliasId, params) {
    return axios
      .get(`/api/project/${aliasId}/${projectAliasId}/issue`, {
        params: HelperS.getRealPagination(params)
      })
      .then((res) => {
        const result = HelperS.parsePagination(res.data);
        store.dispatch('setIssues', result);
        return result;
      });
  },
  addIssue(aliasId, projectAliasId, data) {
    return axios
      .post(`/api/project/${aliasId}/${projectAliasId}/issue`, data, {
        formName: FORM_NAME_ENUMS.PROJECT_ISSUE_FORM
      })
      .then(
        (res) =>
          // NotificationS.success('Проблема успешно создана');
          res.data
      )
      .catch((err) => {
        throw err;
      });
  },
  deleteIssue(aliasId, projectAliasId, issueId) {
    return axios.delete(`/api/project/${aliasId}/${projectAliasId}/issue/${issueId}`).then(() => {
      // NotificationS.success('Проблема успешно удалена');
    });
  },
  editIssue(aliasId, projectAliasId, issueId, data) {
    return axios
      .put(`/api/project/${aliasId}/${projectAliasId}/issue/${issueId}/edit`, data, {
        formName: FORM_NAME_ENUMS.PROJECT_ISSUE_FORM
      })
      .then(
        (res) =>
          // NotificationS.success('Проблема успешно изменена');
          res.data
      )
      .catch((err) => {
        throw err;
      });
  },
  issueChangeStatus(aliasId, projectAliasId, issueId, data) {
    return axios
      .put(`/api/project/${aliasId}/${projectAliasId}/issue/${issueId}/change-status`, data)
      .then((res) => {
        store.dispatch('updateIssueListItemStatus', { id: issueId, status: data });
        return res.data;
      })
      .catch((err) => {
        throw err;
      });
  },
  postComment(aliasId, projectAliasId, issueId, data) {
    return axios
      .post(`/api/project/${aliasId}/${projectAliasId}/issue-discussion/${issueId}/create`, data, {
        formName: FORM_NAME_ENUMS.ISSUE_DISCUSSION_FORM
      })
      .then(
        (res) =>
          // NotificationS.success('Комментарий успешно добавлен');
          // store.dispatch('appendIssueComment', res.data);
          res.data
      )
      .catch((err) => {
        throw err;
      });
  },
  getDiscussions(aliasId, projectAliasId, issueId, params) {
    return axios
      .get(`/api/project/${aliasId}/${projectAliasId}/issue-discussion/${issueId}`, {
        params: HelperS.getRealPagination(params)
      })
      .then((res) => {
        /* if (!append) {
              store.dispatch('setIssueDiscussions', HelperS.parsePagination(res.data));
          } else {
              store.dispatch('appendIssueDiscussions', HelperS.parsePagination(res.data));
          } */
        return HelperS.parsePagination(res?.data);
      });
  },
  deleteDiscussion(aliasId, projectAliasId, issueId, discusId) {
    return axios
      .delete(
        `/api/project/${aliasId}/${projectAliasId}/issue-discussion/${issueId}/${discusId}/delete`
      )
      .then((res) => res.data);
  },
  getIssueDescription(aliasId, projectAliasId, issue, params) {
    return axios
      .get(`/api/project/${aliasId}/${projectAliasId}/issue/${issue.localId}/description`, {
        params
      })
      .then((res) => {
        store.dispatch('setIssueDescription', { issue, data: res.data });
        return res.data;
      })
      .catch((err) => {
        throw err;
      });
  },

  getDiscussionCounterValue(aliasId, projectAliasId, issueId, params) {
    return axios
      .get(`/api/project/${aliasId}/${projectAliasId}/issue-discussion/${issueId}/count`, {
        params
      })
      .then((res) => {
        store.dispatch('setDiscussionsCounter', res.data);
        return res.data;
      });
  },
  editDiscussion(userAlias, projectAlias, issueId, discusId, data) {
    return axios
      .put(
        `/api/project/${userAlias}/${projectAlias}/issue-discussion/${issueId}/${discusId}/edit`,
        {
          note: data
        }
      )
      .then((res) => res.data);
  }
};
